/*
 * classie
 * http://github.amexpub.com/modules/classie
 *
 * Copyright (c) 2013 AmexPub. All rights reserved.
 */

module.exports = require('./lib/classie');



//////////////////
// WEBPACK FOOTER
// ./~/classie/index.js
// module id = ./node_modules/classie/index.js
// module chunks = 5